export default __webpack_public_path__ + "static/media/not_found_icon.57d5f313.svg";